module.exports = "/dist/b670694ba39f55b5ab9b6022eb09d9ef.woff";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-roboto/files/roboto-latin-500italic.woff
// module id = 158
// module chunks = 0